module.exports = __webpack_public_path__ + "static/img/part3.8fc357d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/eng/part3.png
// module id = xvgF
// module chunks = 0